<template>
  <div class="submit">
    <div class="submit-inner">
      <div>Submit</div>
      <div></div>
      <div>Welcome to submit plant lncRNAs to the PLncDB
        <i class="el-icon-download el-icon-upload2" @click="upload"> upload</i>
        <i class="el-icon-download" @click="download"> Download sample</i>
      </div>
      <div>
        If you have a group of novel lncRNAs in plants, and would like to submit them to PLncDB. Please email your lncRNAs to
        <b>jinjingjing1218@126.com, peijiancao@163.com</b> with the following information:
      </div>
      <ul>
        <li v-for="(item, key) in submitData" :key="key">{{ key + 1 }}{{ item }}</li>
      </ul>
      <div>
        Novel lncRNAs will be named after manuscript acceptance. All submissions will be really appreciated!
      </div>
      <div>
        Batch submit can be accepted by gff/gtf format or using our excel template.
      </div>
      <!-- <div>jinjingjing1218@126.com, peijiancao@163.com</div> -->
    </div>
    <!-- 上传弹框 -->

    <el-dialog title="upload" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="500px">
      <el-form :model="form" :rules="rules" ref="form" :inline="true">
        <el-form-item label="Email" prop="email">
          <el-input style="width:380px;" v-model="form.email"></el-input>
        </el-form-item><br>
        <el-form-item label="" prop="fileName">
          <p class="file_p">
            <a href="javascript:;" class="file">Upload file
              <input type="file" name="file" ref="file" @change="handleUpdate($event)" />
            </a>
            <span>{{form.fileName}}</span>
          </p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="sureUpload('form')">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Map",
  data() {
    return {
      submitData: [
        ') Organism (required)',
        ') Genomic location (required)',
        ') Strand (required)',
        ') Exon location (required)',
        ') Name (optional)',
        ') Expression value (optional)'
        // "): Species(required)",
        // "): Chromesome/Scaffold(required)",
        // "): Start(required)",
        // "): End(required)",
        // "): Sequence(required)",
        // "): Exon_Num",
        // "): CPC",
        // "): Peptides length (longest)"
      ],
      dialogFormVisible: false,
      form: {
        email: '',
        fileName: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please enter email address', trigger: 'blur' },
          { type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }
        ]
      },
      file: ''
    };
  },
  mounted() {
  },
  methods: {
    download() {
      const param = {
        name: 'Submit template.xlsx'
      }
      this.jg_downloadFile('user/submit_download', param)
    },
    upload() {
      this.dialogFormVisible = true
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields()
        this.$refs.file.value = ''
        this.file = ''
      }
    },
    handleUpdate(event) {
      if (event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length - 1] != 'xlsx') {
        this.$message.warning('Please upload .xlsx file！');
      } else {
        this.form.fileName = event.target.files[0].name
        this.file = event.target.files[0]
      }
    },
    sureUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.file === '') {
            this.$message.warning('Please upload file！');
          } else {
            let formData = new FormData()
            formData.append('email', this.form.email)
            formData.append('myfile', this.file)
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            this.$axios.post('user/submit_upload_file/', formData, config).then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.msg);
                this.dialogFormVisible = false
              } else {
                this.$message.warning(res.data.msg);
              }
            }).catch(err => {
              this.$message.warning(err.data.msg);
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.submit {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.submit .submit-inner {
  width: 1200px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.submit .submit-inner div:first-child {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
}
.submit .submit-inner div:nth-child(2) {
  width: 100%;
  height: 1px;
  background: rgba(229, 233, 235, 1);
}
.submit .submit-inner div:nth-child(3) {
  height: 25px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin-top: 43px;
}
.submit .submit-inner div:nth-child(4) {
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin-top: 18px;
}
.submit .submit-inner ul {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-top: 50px;
}
.submit .submit-inner ul li {
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
}
.submit .submit-inner div:nth-child(6) {
  width: 100%;
  height: 44px;
  margin-top: 14px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}
/* .submit .submit-inner div:last-child {
  width: 462px;
  height: 40px;
  margin-top: 36px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  background: rgba(139, 182, 68, 1);
} */
b {
  color: rgba(139, 182, 68, 1);
  font-size: 18px;
}
.el-icon-download {
  float: right;
  color: rgb(139, 182, 68);
  font-size: 14px;
  cursor: pointer;
  padding-top: 8px;
  padding-left: 20px;
}
.file_p {
  margin-top: 0;
  margin-left: -5px;
}
.file_p span {
  display: inline-block;
  padding-left: 30px;
}
.file {
  position: relative;
  display: inline-block;
  background: rgba(139, 182, 68, 1);
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  text-indent: 0;
  line-height: 30px;
  cursor: pointer;
  width: 100px;
  height: 30px;
  text-align: center;
  top: 8px;
  left: 15px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.file:hover {
  color: #fff;
  text-decoration: none;
}
</style>
<style>
.el-button--primary {
  background-color: #8bb644 !important;
  border-color: #8bb644 !important;
}
</style>
